import Box from '@mui/material/Box';
import { LoadingButton, TextField } from '../common';
import { useLogin } from './hooks';

import { ErrorBar } from '../error-bar';
import classes from './login-form.module.css';

const InvalidError = 'Invalid email address or order.';

export const LoginForm = () => {
  const {
    email,
    orderId,
    isBtnDisable,
    emailHelperText,
    orderIdHelperText,
    isEmailValid,
    isOrderIdValid,
    isLoading,
    isInvalidBarShow,
    emailLabelText,
    onClickBtn,
    onChangeEmail,
    onChangeOrderId,
  } = useLogin();

  return (
    <Box
      component="form"
      noValidate
      autoComplete="off"
    >
      {isInvalidBarShow.show && (
        <ErrorBar
          message={isInvalidBarShow.message || InvalidError}
          canClose={false}
          className={classes.error}
        />
      )}
      <section className={classes.input_block}>
        <TextField
          id="login-email-input"
          label={emailLabelText}
          placeholder={emailLabelText}
          variant="outlined"
          color="input"
          error={!isEmailValid}
          defaultValue={email}
          helperText={emailHelperText}
          onChange={onChangeEmail}
        />
      </section>
      <section className={classes.input_block_second}>
        <TextField
          id="login-order-id-input"
          label="Worry-Free Purchase ID / Order Number"
          placeholder="Worry-Free Purchase ID / Order Number"
          variant="outlined"
          color="input"
          error={!isOrderIdValid}
          defaultValue={orderId}
          helperText={orderIdHelperText}
          onChange={onChangeOrderId}
        />
      </section>
      <LoadingButton
        disabled={isBtnDisable}
        loading={isLoading}
        classes={{
          root: classes.login_btn,
          disabled: classes.disable_btn,
        }}
        onClick={onClickBtn}
        id="login_next"
      >
        {isLoading ? '' : 'Next'}
      </LoadingButton>
    </Box>
  );
};
